import "./Styles/Cookies.css";
import { BrowserRouter, Routes, Route, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Fragment } from "react";
import ReactGA from "react-ga";
import { createBrowserHistory } from "history";

import axios from "axios";


import CanadaMain from "./Canada/Components/Home/Main";
import CanadaGapAnalysis from "./Canada/RedirectingPages/NavbarPages/BusinessAudit";
import CanadaBespokeSystem from "./Canada/RedirectingPages/NavbarPages/BespokeSystem";
import CanadaWebDevelopment from "./Canada/RedirectingPages/NavbarPages/BusinessAutomation";
import CanadaDigitalMarket from "./Canada/RedirectingPages/NavbarPages/SoftwareDevelopment";
import CanadaMobileApp from "./Canada/RedirectingPages/NavbarPages/MobileApp";
import CanadaDedicatedResource from "./Canada/RedirectingPages/NavbarPages/DedicatedResource";
import CanadaAboutUs from "./Canada/RedirectingPages/FooterPages/AboutCompany";
import CanadaContactUs from "./Canada/RedirectingPages/FooterPages/ContactUs";
import CanadaCareer from "./Canada/RedirectingPages/FooterPages/Career";
import CanadaMainTestimonial from "./Canada/RedirectingPages/FooterPages/MainTestimonial";
import CanadaPricingTable from "./Canada/RedirectingPages/FooterPages/PricingTable";
import CanadaSeoManagement from "./Canada/RedirectingPages/Packages/SeoManagement";
import CanadaBlog from "./Canada/RedirectingPages/FooterPages/Blog";
import CanadaBlogDetails from "./Canada/RedirectingPages/FooterPages/AllBlogs/BlogDetails";
import CanadaPolicy from "./Canada/RedirectingPages/FooterPages/Policy";
import CanadaDigitalMarketing from "./Canada/RedirectingPages/FooterPages/DigitalMarketing";
import CanadaHostingServices from "./Canada/RedirectingPages/FooterPages/HostingServices";
import CanadaMicroService from "./Canada/RedirectingPages/FooterPages/MicroService";
import CanadaAllGallery from "./Canada/RedirectingPages/AllGallery";
import CanadaCurrentOPening from "./Canada/RedirectingPages/FooterPages/CurrentOPening";
import CanadaDetails2 from "./Canada/RedirectingPages/FooterPages/CareerDetails/Details2";
import CanadaEmployeeVideo from "./Canada/RedirectingPages/EmployeeVideo";
import CanadaWebsiteDevelopment from "./Canada/RedirectingPages/NavbarPages/WebsiteDevelopment";
import ScrollTop from "./Canada/RedirectingPages/NavbarPages/ScrollTop";
import CallBack from "./Canada/RedirectingPages/NavbarPages/CallBack";
import CaseStudy1 from "../src/Canada/Components/Case Studies/CaseStudy1";
// import 'react-tabs/style/react-tabs.css';

ReactGA.initialize("UA-76559070-1");
const browserHistory = createBrowserHistory();
browserHistory.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search);
});

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const [ip, setIP] = useState("");
  const [long, setLong] = useState("");
  const [latt, setLatt] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState('')

  const getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setLatt(res.data.latitude);
    setLong(res.data.longitude);
    setIP(res.data.IPv4);
    setCity(res.data.city);

    setCountry(res.data.country_name)
  };
  useEffect(() => {
    getData();
  }, []);

  const [shown, setShown] = useState(true);

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 2 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + true + ";" + expires + ";path=/zithas-usa";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      setCookie("zithasTech", user, 30);
    }
    localStorage.setItem("latitude", latt);
    localStorage.setItem("longitude", long);
    localStorage.setItem("IpAddress", ip);
    localStorage.setItem("City", city);
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";
    // }
  }

  // useEffect(() => {
  //   let user = getCookie("zithasTech");
  //   if (user != "") {
  //     var x = document.getElementById("cookiesBox");
  //     x.style.display = "none";
  //   }
  // }, []);

  function checkCookieBanner() {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      var x = document.getElementById("cookiesBox");
      x.style.display = "block";
    }
  }

  const onDecline = () => {
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";
  };

  const onSaveSettings = () => {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      setCookie("zithasTech", user, 30);
    }
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";

    var checkBox = document.getElementById("analytics_cookies");
    if (checkBox.checked == true) {
      localStorage.setItem("latitude", latt);
      localStorage.setItem("longitude", long);
      localStorage.setItem("IpAddress", ip);
      localStorage.setItem("City", city);
    } else if (checkBox.checked == false) {
      return false;
    }

    var checkBox = document.getElementById("functional_cookies");
    if (checkBox.checked == true) {
      console.log("Functional Coocikes is Acctivated");
    } else {
      console.log("Functional Coocikes is Deacctivated");
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Fragment>
          {/* <ScrollToTop /> */}
          <ScrollTop />
          <CallBack />
          <Routes>
            {/* Canada Routes */}

            <Route exact path="/" element={<CanadaMain />}></Route>
            <Route exact path="/business-automation" element={<CanadaWebDevelopment />} ></Route>
            <Route exact path="/business-software-audit" element={<CanadaGapAnalysis />} ></Route>
            <Route exact path="/bespoke-systems" element={<CanadaBespokeSystem />} ></Route>
            <Route exact path="/custom-software-development" element={<CanadaDigitalMarket />} ></Route>
            <Route exact path="/website-development" element={<CanadaWebsiteDevelopment />} ></Route>
            <Route exact path="/mobile-apps-development" element={<CanadaMobileApp />} ></Route>
            <Route exact path="/hire-a-resource" element={<CanadaDedicatedResource />} ></Route>
            <Route path="/case-study/:permalink" element={<CaseStudy1/>} />
            <Route exact path="/about-us" element={<CanadaAboutUs />} ></Route>
            <Route exact path="/contact-us" element={<CanadaContactUs />} ></Route>
            <Route exact path="reer" element={<CanadaCareer />} ></Route>
            <Route exact path="/testimonials" element={<CanadaMainTestimonial />} ></Route>
            <Route exact path="/Maintenance-Packages" element={<CanadaPricingTable />} ></Route>
            <Route exact path="/seo-management-packages" element={<CanadaSeoManagement />} ></Route>
            <Route exact path="/blog" element={<CanadaBlog />} ></Route>
            <Route exact path="/blog/:permalink" element={<CanadaBlogDetails />} ></Route>
            <Route exact path="/privacy-policy" element={<CanadaPolicy />} ></Route>
            <Route exact path="/digital-marketing" element={<CanadaDigitalMarketing />} ></Route>
            <Route exact path="/hosting-service" element={<CanadaHostingServices />} ></Route>
            <Route exact path="/micro-service" element={<CanadaMicroService />} ></Route>
            <Route exact path="/gallery" element={<CanadaAllGallery />} ></Route>
            <Route exact path="/current-opening" element={<CanadaCurrentOPening />} ></Route>
            <Route exact path="/current-opening/:permalink" element={<CanadaDetails2 />} ></Route>
            <Route exact path="/employee-testimonial" element={<CanadaEmployeeVideo />} ></Route>


          </Routes>

          {/* <div className="bd-fade-cookie">
            <div>
              <div
                id="cookiesBox"
                style={{
                  display: "flex",
                  position: "fixed",
                  bottom: "0px",
                  zIndex: "999",
                  padding: "20px",
                  backgroundColor: "#353535",
                  width: "100%",
                }}
              >
                <div style={{ width: "66%" }}>
                  We are using cookies to give you the best experience on our
                  website. See our{" "}
                  <Link
                    to="/privacy-policy"
                    style={{
                      textDecoration: "underline",
                      color: "rgb(255, 191, 30)",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    Privacy Policy{" "}
                  </Link>{" "}
                  for More.
                  <br />
                  You can find out more about which cookies we are using or
                  switch them off in settings.
                </div>
                <div className="bd-cookies-section2" style={{ width: "13%" }}>
                  <button
                    className="bd-setting-cookie"
                    data-bs-toggle="modal"
                    data-bs-target="#cookieModal"
                    id="rcc-confirm-button"
                    aria-label="Accept cookies"
                  >
                    Cookie Setting
                  </button>
                </div>

                <div style={{ width: "11%" }}>
                  <button
                    style={{
                      color: "black",
                      fontWeight: "600  ",
                      backgroundColor: "rgb(255, 191, 30)",
                      marginTop: "0px",
                      borderRadius: "10px",
                      padding: "10px",
                      width: "120px",
                      border: "none",
                    }}
                    onClick={checkCookie}
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Accept
                  </button>
                </div>
                <div>
                  <button
                    style={{
                      marginTop: "0px",
                      borderRadius: "10px",
                      padding: "10px",
                      width: "120px",
                      backgroundColor: "rgb(195, 41, 72)",
                      color: "white",
                      fontWeight: "600",
                      border: "none",
                    }}
                    onClick={onDecline}
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          </div>

          {shown && (
            <div
              className="modal fade "
              id="cookieModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-xl modal-dialog-centered mt-75">
                <div
                  className="modal-content "
                  style={{
                    maxWidth: "800px",
                    paddingLeft: "0px",
                    paddingRight: "20px",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    className="modal-header"
                    style={{ borderBottom: "1px solid black" }}
                  >
                    <h5 className="modal-title w100" id="exampleModalLabel">
                      Privacy Preference Center
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{ marginLeft: "50px" }}
                    ></button>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <div className="bd-tab">
                        <Tabs>
                          <div className="bd-modal-cookie-1">
                            <TabList>
                              <Tab style={{ borderTop: "none" }}>
                                Your Privacy
                              </Tab>
                              <Tab>Strictly Necessary Cookies</Tab>
                              <Tab>Analytics Cookies</Tab>
                            </TabList>
                          </div>

                          <div className="bd-modal-cookie-2">
                            <TabPanel>
                              <h6>Your Privacy</h6>
                              <p className="bd-cookie-text">
                                At zithas we care about your privacy and believe
                                in transparency. That’s why we are committed to
                                being upfront about our privacy practices and
                                provide settings that allow you to choose how
                                certain information is used. Our Site uses
                                Cookies to identify you. Cookies can store your
                                account identifier, ordering status,
                                personalisation or website tracking. They can
                                also be used for technical purposes such as
                                keeping track of your current shopping session
                                or to save information for your languages
                                preferences, so that we can offer improved and
                                more personalised services, products and other
                                relevant communication tailored to you,
                                including to display targeted, or interest-based
                                offers based on the products you currently own
                                or have recently viewed.
                              </p>
                            </TabPanel>
                            <TabPanel>
                              <h6>Strictly Necessary Cookies</h6>
                              <p className="bd-cookie-text">
                                These cookies are necessary for the website to
                                function and cannot be switched off in our
                                systems. They are usually only set in response
                                to actions made by you which amount to a request
                                for services, such as setting your privacy
                                preferences, logging in or filling in forms. You
                                can set your browser to block or alert you about
                                these cookies, but some parts of the site will
                                not then work. These cookies do not store any
                                personally identifiable information.{" "}
                              </p>
                            </TabPanel>

                            <TabPanel>
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{ paddingTop: "5px", width: "92%" }}
                                >
                                  <h6>Analytics Cookies</h6>
                                </div>
                                <div>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="analytics_cookies"
                                      style={{ fontSize: "20px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <p className="bd-cookie-text">
                                These cookies allow us to count visits and
                                traffic sources so we can measure and improve
                                the performance of our site. They help us to
                                know which pages are the most and least popular
                                and see how visitors move around the site. All
                                information these cookies collect is aggregated
                                and therefore anonymous. If you do not allow
                                these cookies we will not know when you have
                                visited our site, and will not be able to
                                monitor its performance.
                              </p>
                            </TabPanel>
                          </div>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      paddingTop: "25px",
                      borderTop: "1px solid rgba(0,0,0,0.4)",
                    }}
                  >
                    <div className="bd-btns-cookie">
                      <button
                        className="bd-save-cookie-sett"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        taIndex="0"
                        id="rcc-confirm-button"
                        onClick={onSaveSettings}
                      >
                        Save Settings
                      </button>
                    </div>
                    <div className="bd-btns-cookie2">
                      <button
                        className="bd-save-cookie-sett"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={checkCookie}
                      >
                        Allow All cookies
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </Fragment>
      </BrowserRouter>
    </div>
  );
}

export default App;
